import {Component, Input, OnInit} from '@angular/core';
import {BlockDetailService} from '../../../shared/services/block-detail.service';
import {DisplayBlockType} from '../../timeline/timeline.component';
import moment from 'moment';
import {SearchService} from '../../../shared/services/search.service';
import {BlockCategoryType} from '../../../../gql/graphql';
import {Clipboard} from '@angular/cdk/clipboard';
import {DomSanitizer, SafeResourceUrl} from '@angular/platform-browser';

@Component({
  selector: 'app-standard-block',
  templateUrl: './standard-block.component.html',
  styleUrls: ['./standard-block.component.scss']
})
export class StandardBlockComponent implements OnInit {

  @Input() block: DisplayBlockType | null = null;
  beginDate = '';
  endDate = '';
  gatheringDate = '';
  showActive = false;
  animationActive = false;
  animationTimeout: ReturnType<typeof setTimeout> | undefined;
  copied = false;
  downloadFile: {type: string, url: string | SafeResourceUrl} | null = null;

  constructor(private blockDetailService: BlockDetailService,
              private searchService: SearchService,
              private clipboard: Clipboard,
              private sanitizer: DomSanitizer) { }

  ngOnInit(): void {
    if (this.block) {
      this.beginDate = moment(this.block.beginDate, 'DD-MM-YYYY').toString();
      this.endDate = moment(this.block.endDate, 'DD-MM-YYYY').toString();
      this.gatheringDate = moment(this.block.gatheringDate, 'DD-MM-YYYY').toString();
    }
    if (this.block?.downloadFile) {
      if (this.block.downloadFile.type === 'VIDEO') {
        
        this.downloadFile = {
          type: this.block.downloadFile.type,
          url: this.sanitizeVimeoUrl('https://player.vimeo.com/video/' + this.block.downloadFile.videoUrl + '?title=0&byline=0&portrait=0')
        }
      } else {
        const fileUrl = this.block?.downloadFile?.file?.url;
        this.downloadFile = fileUrl
          ? {
            type: this.block.downloadFile.type,
            url: fileUrl
          }
          : null;
      }
    }

    this.searchService.getActiveBlockId().subscribe(output => {
      this.showActive = output === this.block?.displayId;
      this.animationActive = true;

      if (this.animationTimeout) {
        clearTimeout(this.animationTimeout);
      }

      this.animationTimeout = setTimeout(() => {
        this.animationActive = false;
      }, 10000);

    });
  }

  copyToClipboard(): void {
    this.copied = true;
    this.clipboard.copy(window.location.origin + '?share=' + this.block?.displayId);
    setTimeout(() => {
      this.copied = false;
    }, 1000)
  }

  getAnimationStyle(): string {
    if (this.showActive && this.animationActive && this.block) {
      if (this.block.category === BlockCategoryType.POVO) {
        return 'flashingBorderPOVO ';
      } else if (this.block.category === BlockCategoryType.VO) {
        return 'flashingBorderVO ';
      } else if (this.block.category === BlockCategoryType.PO) {
        return 'flashingBorderPO ';
      }
    }
    return ''
  }

  toggleDetailView() {
    if (this.block) {
      this.blockDetailService.setBlockDetailSelection(this.block, true);
    }
  }

  sanitizeVimeoUrl(url: string): SafeResourceUrl {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }
}
